import type { IndividualPaymentSaveViewModel } from '@/shared/api/generated';

import type { PlanFormValues } from '../hooks/usePlanFormSchema';

/**
 * Monta o corpo do `POST` de criação do plano financeiro.
 *
 * Diferente de `buildPlanSavePayload`, não há base a preservar: o corpo é o
 * formulário e nada mais. Os `PASSTHROUGH_KEYS` da edição existem para devolver
 * intactos campos que vieram do editor — na criação não existe editor, e todo
 * campo ausente é ausência de verdade, não perda de dado.
 *
 * Dois campos são deliberadamente retirados:
 *
 * - `personId` é seletor de UI, não faz parte do `IndividualPaymentSaveViewModel`
 *   — o backend deriva a pessoa do `courseRegistrationId`;
 * - `id` não é enviado: quem atribui o id do contrato é o backend.
 *
 * @param values - Valores atuais do formulário de criação.
 * @returns Corpo do `POST`.
 *
 * @example
 * ```ts
 * const payload = buildPlanCreatePayload(form.getValues());
 * // payload.personId === undefined
 * ```
 */
export function buildPlanCreatePayload(values: PlanFormValues): IndividualPaymentSaveViewModel {
  const { personId: _personId, ...savable } = values;

  return savable as IndividualPaymentSaveViewModel;
}
